import React from 'react';
import PropTypes from 'prop-types';

import { buildMiroEmbedURL } from '@techchange/integrations';

const propTypes = {

	/**
	 * The unique ID for the content.
	 */
	id: PropTypes.string.isRequired,

	/**
	 * Additional data for the content.
	 */
	data: PropTypes.shape({

		/**
		 * The Miro board ID.
		 */
		board_id: PropTypes.string.isRequired,

		/**
		 * The Miro team ID.
		 */
		team_id: PropTypes.string.isRequired,

	}).isRequired,

	/**
	 * The title to display.
	 */
	title: PropTypes.string.isRequired,

	/**
	 * Flag indicating if the content title should be visible.
	 */
	showTitle: PropTypes.bool.isRequired,

};

const ContentDisplay = (props) => {

	const {
		id,
		data,
		title,
		showTitle,
	} = props;

	if (!data) {
		return null;
	}

	const miroEmbedURL = buildMiroEmbedURL(data.board_id);

	return (
		<div className={`miro-board-${id}`}>
			{showTitle &&
				<span className="title">
					<h5 style={{ margin: 0 }}>
						{title}
					</h5>
				</span>
			}
			<div className="ratio ratio-16x9">
				<iframe
					src={miroEmbedURL}
					title={title}
					frameBorder="0"
					scrolling="no"
					allowFullScreen />
			</div>
		</div>
	);

};

ContentDisplay.propTypes = propTypes;

export default ContentDisplay;
